import { render, staticRenderFns } from "./EntregaErroComprometimento.vue?vue&type=template&id=18e96916"
import script from "./EntregaErroComprometimento.vue?vue&type=script&lang=js"
export * from "./EntregaErroComprometimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports